var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17.86,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.902 0H20.098C20.596 0 21 0.404 21 0.902V20.098C21 20.596 20.596 21 20.098 21H0.902C0.404 21 0 20.596 0 20.098V0.902C0 0.404 0.404 0 0.902 0ZM1.353 0.902C1.104 0.902 0.902 1.104 0.902 1.353V19.647C0.902 19.896 1.104 20.098 1.353 20.098H19.647C19.896 20.098 20.098 19.896 20.098 19.647V1.353C20.098 1.104 19.896 0.902 19.647 0.902H1.353Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.493 4.560L11.462 4.162L17.778 19.952L16.809 20.349L10.493 4.560Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.343 1.749L20.559 2.763L0.559 6.974L0.343 5.960L20.343 1.749Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9774 13.3401C10.9774 15.6116 8.72481 17.2074 7.74271 17.7959C7.60693 17.8773 7.45157 17.9203 7.29323 17.9203C7.13489 17.9203 6.97953 17.8773 6.84376 17.7959C5.86165 17.2074 3.60902 15.6116 3.60902 13.339C3.60902 11.1106 5.39428 9.62428 7.29323 9.62428C9.25849 9.62428 10.9774 11.1106 10.9774 13.3401ZM10.45 13.34C10.45 15.29 8.52 16.65 7.68 17.16C7.56 17.23 7.43 17.27 7.29 17.27C7.16 17.27 7.03 17.23 6.91 17.16C6.07 16.65 4.14 15.29 4.14 13.34C4.14 11.43 5.67 10.16 7.29 10.16C8.97 10.16 10.45 11.43 10.45 13.34Z",
    fill: "#3D3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29323 14.3611C7.87458 14.3611 8.34586 13.8898 8.34586 13.3085C8.34586 12.7271 7.87458 12.2559 7.29323 12.2559C6.71188 12.2559 6.2406 12.7271 6.2406 13.3085C6.2406 13.8898 6.71188 14.3611 7.29323 14.3611Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketAreas);
export default __webpack_public_path__ + "static/media/marketAreas.eace0d2244644e2184377aa6176dff4f.svg";
export { ForwardRef as ReactComponent };